import React from "react";
import Layout from "layouts";
import BlackoutDatesComponent from "./BlackoutDatesComponent";

export default function BlackoutDates() {
  return (
    <Layout breadCrumb={[{ label: "Blackout Dayes", to: "#" }]}>
      <BlackoutDatesComponent />
    </Layout>
  );
}
